export default __webpack_public_path__ + "static/media/vd-screenshot-security.64dc2f3e.png";